import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import { useNavigate } from 'react-router';

import { t } from '@/lib/utils';
import { DEFAULT_ROUTE } from '@/routes/Router';

const NotFoundError = () => {
    const navigate = useNavigate();
    return (
        <ApplicationLayout.Body>
            <NotFoundState
                headline={t('general.notFound.heading')}
                message={t('general.notFound.message')}
                buttons={[
                    {
                        text: t('general.notFound.button'),
                        onClick: () => {
                            navigate(DEFAULT_ROUTE);
                        },
                    },
                ]}
            />
        </ApplicationLayout.Body>
    );
};

export default NotFoundError;
